@if (interfaceData.data.length === 0) {
    <p class="empty">No system interfaces in this view. An interface is where information supplied by one system is used by an action that another system automates, or that a role uses another system for.</p>
}@else {
    <p class="summary">{{interfaceData.data.length}} interface{{interfaceData.data.length === 1 ? '' : 's'}} from {{systemCount}} system{{systemCount === 1 ? '' : 's'}}: information supplied by one system and used with another. Select a heading to sort.</p>
    <div class="table-wrapper">
        <table mat-table [dataSource]="interfaceData" matSort>
            @for (column of columns; track column; let i = $index) {
                <ng-container matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [class.numeric]="column === 'time' || column === 'cost'">
                        <span class="image-text">
                            @if (icons[i]) {
                                <app-node-svg [type]="icons[i]"/>
                            }
                            {{headings[i]}}
                        </span>
                    </th>
                    <td mat-cell *matCellDef="let element" [class.numeric]="column === 'time' || column === 'cost'">
                        @if (column === 'time') {
                            {{element[column] | number:'1.0-0'}}
                        }@else if (column === 'cost') {
                            {{element[column] | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                        }@else {
                            {{element[column]}}
                        }
                    </td>
                </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let element; columns: columns;"></tr>
        </table>
    </div>
}
